export default "__VITE_ASSET__DdWbdhZR__"